<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="orginfo" :rules="rules" ref="sysconfigrule" label-width="120px" class="">
			<el-row>
				<el-col :span="12">
					<el-form-item label="名称" prop="name">
						<el-input clearable :disabled="!editok" v-model="orginfo.name" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="编码" prop="id">
						<el-input clearable v-model="orginfo.id" :disabled="!add" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="上级组织" prop="parentid">
						<el-cascader :disabled="!editok" v-model="parentorgid" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="类型" prop="type">
						<el-select style="width: 100%;" filterable clearable :disabled="!editok" v-model="orginfo.type" placeholder="请选择类型">
							<el-option v-for="item in typelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="排序" prop="idx">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="orginfo.idx" :precision="2" :min="0" :max="999" label="排序"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="组织图片" prop="picurl">
						<el-input clearable v-model="orginfo.picurl" :disabled="!editok" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="24">
					<el-form-item label="组织图片" >
						<el-upload :disabled="!editok" :action="fileuploadUrl" :file-list="midPicture"
							:before-upload="(file) => handleBeforeUpload(file) "
							list-type="picture-card" :limit="1" :multiple="false" :on-error="handleUploadError"
							:on-preview="handlePictureCardPreview" :headers="uploadheader"
							:on-remove="(file, fileList) => handleRemove(file, fileList)" 
							:on-exceed="(file, fileList) => handleExceed(file, fileList)"
							:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList)">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-col> -->
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveOrgInfos">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { addSysOrg,editSysOrg,queryAllOrg,queryAllOrgTree,
		deleteSysFile} from '/static/apiUrl.js'
	import { baseUrl, nfsprefix, prefix } from '/public/baseUrl.js'
	export default {
		name : 'OrgDetail',
		data() {
			return {
				editok: false,
				parentorgid : '',
				disabled_cord: false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},
				fileuploadUrl : baseUrl + prefix + localStorage.getItem("citycode") +'/api/public/upload',
				midPicture : [],
				typelist : [
					{
						code : 'JG',
						name : '机构'
					},
					{
						code : 'XQ',
						name : '校区'
					}
				],
				orginfo : {
					id: "",
					name: "",
					parentid : "",
					type : "",
					idx : 0,
					picurl: null,
					opic : ''
				},			
				rules:{
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					id: [
						{ required: true, message: '请输入编码', trigger: 'blur' }
					],
					type: [
						{ required: true, message: '请选择类型', trigger: 'blur' }
					]
				},
				allOrgTree : [],
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectorg : {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			}
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectorg: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)		
					if (newVal != null && newVal != "") {						
						this.disabled_cord = true
						this.orginfo.id = newVal.id
						this.orginfo.name = newVal.name
						this.orginfo.parentid = newVal.parentid
						this.parentorgid = newVal.parentid
						this.orginfo.type = newVal.typecode
						this.orginfo.idx = newVal.idx
						this.orginfo.opic = newVal.opic
						this.orginfo.picurl = newVal.opic //newVal.picurl
						if(newVal.opic){
							this.midPicture = []
							this.midPicture.push({
								name : newVal.name,
								url : baseUrl+ nfsprefix + newVal.opic,
								size : 0
							})
						}
					}else{
						this.orginfo.id = ''
						this.orginfo.name = ''
						this.orginfo.parentid = ''
						this.orginfo.type = ''
						this.orginfo.idx = 0
						this.orginfo.picurl = ''
						this.disabled_cord = false
						this.midPicture = []
						this.parentorgid = ''
					}
				}
			},
		},
		methods: {
			initOrgTree(){
				this.allOrgTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveOrgInfos(){
				this.$refs["sysconfigrule"].validate((valid) => {
					if (valid) {
						const isArr = Array.isArray(this.parentorgid);
						if(isArr && this.parentorgid.length > 0){
							this.orginfo.parentid = this.parentorgid[this.parentorgid.length -1]
						}else{
							this.orginfo.parentid = this.parentorgid
						}
						if(this.add == false){  //编辑
							editSysOrg(this.orginfo).then(res => {
								//console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("修改成功")
								}else{
									this.$message.error(res.messge,true)
								}
							})
						}else{ //新增
							if(this.midPicture.length > 0 && this.midPicture[0].uploadurl){
								this.orginfo.picurl = this.midPicture[0].uploadurl
							}
							addSysOrg(this.orginfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("添加成功")
								}else{
									this.$message.error(res.messge)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
			handleRemove(file, fileList,type) {
				console.log(file, fileList);
				let fid  = this.midPicture[0].uploadurl
				deleteSysFile({filename : fid}).then(res => {
					if(0 == res.code){
						this.midPicture.splice(0,1)
					}
				})
			},
			handlePictureCardPreview(file) {
				this.pictureImageUrl = file.url
				this.pictureVisible = true
			},
			handleUploadSucc(response, file, fileList){
				console.log(response,file,fileList)
				if(0 == response.code){
					this.midPicture.push({
						name : file.name,
						url : file.url,
						uploadurl : response.datas,
						size : file.size
					})
				}else{
					this.$message.error("上传失败")
					file.status = "error"
					fileList.splice(0,1)
				}
			},
			handleUploadError(err, file, fileList){
				console.log(err,file,fileList)
			},
			handleExceed(file, fileList){
				if(this.midPicture.length >0){
					this.$message.warning("只能上传一张图片")
				}
			},
			handleBeforeUpload(file){
				let types = [
					"image/jpeg",
					"image/jpg",
					"image/png"
				];
				const isImage = types.includes(file.type);
				const isLtSize = file.size / 1024 / 1024 < 1;
				if (!isImage) {
					this.$message.warning("上传图片只能是 JPG、JPEG、PNG 格式!");
					return false;
				}
				if (!isLtSize) {
					this.$message.warning("上传图片大小不能超过 1MB!");
					return false;
				}
				return file
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>